import React from "react"
import { motion } from 'framer-motion'
import home1 from '../../Assets/Images/home1.png'
import { useTranslation } from "react-i18next"
import Button from "../../Components/Button"
import { FaArrowRightLong } from "react-icons/fa6";
import home2 from '../../Assets/Images/home2.png'
import home3 from '../../Assets/Images/home3.png'
import home4 from '../../Assets/Images/home4.png'
import home5 from '../../Assets/Images/home5.png'
import home6 from '../../Assets/Images/home6.png'
import home7 from '../../Assets/Images/home7.png'
import { useHistory } from "react-router-dom"

const HomePage = () => {
    const { t } = useTranslation()
    const history = useHistory()
    return (
        <motion.div className="w-full relative min-h-screen flex flex-col gap-8">
            {/* Hero Section */}
            <motion.div className="bg-orangeColor flex flex-col-reverse md:flex-row items-center px-6 md:px-20 py-10 gap-10">
                <motion.div className="flex w-full flex-col gap-6">
                    <p className="text-2xl md:text-4xl text-white font-bold leading-snug">
                        {t('Where Love Meets Destiny Find Your Perfect Match Today!')}
                    </p>
                    <p className="text-base md:text-xl max-w-full md:max-w-[600px] text-black font-bold leading-relaxed">
                        {t('We understand that finding a life partner is one of the most significant decisions in your life. Our goal is to make this journey as smooth and joyful as possible.')}
                    </p>
                    <Button type="primary" injectClass="w-fit px-4 py-2 text-lg md:text-2xl flex flex-row cursor-pointer items-center gap-2" onClick={()=>history.push('/auth/login')}>
                        {t(`Let's Start`)} <FaArrowRightLong />
                    </Button>
                </motion.div>
                <img src={home1} alt="home" className="w-full md:w-1/2 object-contain" />
            </motion.div>

            {/* Section Divider */}
            <motion.div className="w-full flex flex-col md:flex-row gap-4 my-5 px-6 md:px-20 items-center">
                <motion.div className="h-0.5 w-full bg-primeColor"></motion.div>
                <p className="text-lg font-bold text-primeColor text-center">{t('Why Choose Us?')}</p>
                <motion.div className="h-0.5 w-full bg-primeColor"></motion.div>
            </motion.div>

            {/* Section 1 */}
            <motion.div className="flex flex-col md:flex-row items-center px-6 md:px-20 gap-10">
                <motion.div className="flex w-full flex-col gap-5">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">{t('Extensive Database')}</p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`We have a diverse and extensive database of profiles, ensuring that you have numerous options to find your ideal match. Whether you're looking for someone from your community or someone who shares your professional background, we have it all.`)}
                    </p>
                </motion.div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={home2} alt="section" className="w-full md:w-96 object-contain" />
                </div>
            </motion.div>

            {/* Section 2 */}
            <motion.div className="flex flex-col-reverse md:flex-row items-center px-6 md:px-20 gap-10">
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={home3} alt="section" className="w-full md:w-96 object-contain" />
                </div>
                <motion.div className="flex w-full flex-col gap-5">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">{t('Verified Profiles')}</p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`Your safety and security are our top priorities. All profiles are thoroughly verified to ensure genuine connections. You can trust that the people you meet on our platform are real and serious about finding a life partner.`)}
                    </p>
                </motion.div>
            </motion.div>

            {/* Section 3 */}
            <motion.div className="flex flex-col md:flex-row items-center px-6 md:px-20 gap-10">
                <motion.div className="flex w-full flex-col gap-5">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">{t('Advanced Matchmaking')}</p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`Our advanced algorithm and personalized matchmaking services help you find compatible matches based on your preferences and lifestyle. We take into account various factors, include personality, interests, and cultural background, to suggest the best possible matches.`)}
                    </p>
                </motion.div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={home4} alt="section" className="w-full md:w-96 object-contain" />
                </div>
            </motion.div>

            {/* Section 4 */}
            <motion.div className="flex flex-col-reverse md:flex-row items-center px-6 md:px-20 gap-10">
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={home5} alt="section" className="w-full md:w-96 object-contain" />
                </div>
                <motion.div className="flex w-full flex-col gap-5">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">{t('Privacy and Security')}</p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`We respect your privacy and ensure that your personal information is kept secure. Our robust security measures protect your data, allowing you to focus on building meaningful connections.`)}
                    </p>
                </motion.div>
            </motion.div>

            {/* Section 5 */}
            <motion.div className="flex flex-col md:flex-row items-center px-6 md:px-20 gap-10">
                <motion.div className="flex w-full flex-col gap-5">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">{t('Expert Guidance')}</p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`Our team of experienced relationship experts and counselors are here to guide you through every step of the process. From creating an attractive profile to providing tips to successful communication, we are with you all the way.`)}
                    </p>
                </motion.div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={home6} alt="section" className="w-full md:w-96 object-contain" />
                </div>
            </motion.div>

            {/* Final Call to Action */}
            <motion.div className="relative h-[450px] z-10 md:h-96 w-full flex flex-col">
                <img src={home7} alt="cta" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <motion.div className="relative z-10 px-6 md:px-40 py-10 flex flex-col justify-center items-start gap-5 h-full">
                    <p className="text-2xl md:text-4xl text-primeColor font-bold">
                        {t(`Join Today! Start your journey towards a happy future`)}
                    </p>
                    <p className="text-base md:text-xl text-black font-bold leading-relaxed">
                        {t(`Sign up now and take the first step towards finding your life partner. Your journey to a happy and fulfilling marriage starts here`)}
                    </p>
                    <Button type="primary" injectClass="w-fit px-4 py-2 text-lg md:text-2xl flex flex-row items-center cursor-pointer gap-2" onClick={()=>history.push('/auth/login')}>
                        {t(`Join now`)} <FaArrowRightLong />
                    </Button>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default HomePage